import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { DadosSeparacao } from 'src/app/models/dados-separacao';
import { DadosSeparacaoTransporte } from 'src/app/models/dados-separacao-tranporte';
import { Monitor } from 'src/app/models/monitor';
import { Transportadora } from 'src/app/models/transportadora';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { TransportadoraService } from 'src/app/services/transportadora.service';

@Component({
  selector: 'app-dados-monitores-modal',
  templateUrl: './dados-monitores-modal.component.html',
  styleUrls: ['./dados-monitores-modal.component.scss']
})
export class DadosMonitoresModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  dadosSeparacao: DadosSeparacao = new DadosSeparacao();
  dadosSeparacaoTransporte: DadosSeparacaoTransporte = new DadosSeparacaoTransporte();
  codErp = '';
  idCupom = '';
  tipo = 0;
  tiposDeEntrega = [{ id: 0, nome: 'Cliente Retira' }, { id: 1, nome: 'Transportadora' }];
  tipoFrete;
  valorFrete = 0;
  separacaoTransporte = false;
  transportadoras: Transportadora[] = [];
  public MASKS = MASKS;
  texto = '';
  obrigarPreencherCampos: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DadosMonitoresModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private pedidoService: PedidoService,
    private transportadoraService: TransportadoraService,
    private premissasService: PremissasService
  ) { }

  ngOnInit() {
    this.idCupom = this.data.idCupom;
    this.tipo = this.data.tipo;
    this.codErp = this.data.codErp;
    this.separacaoTransporte = this.data.separacaoTransporte;
    this.tipoFrete = this.data.tipoFrete;
    this.valorFrete = this.data.valorFrete;

    this.buscarDadosSeparacao();

    switch (this.tipo) {
      // integração
      case 1:
        this.texto = 'Dados de integração do pedido ' + this.idCupom;
        this.codErp = this.data.codErp;
        break;

      // separação
      case 4: {
        if (this.separacaoTransporte) {
          this.texto = 'Dados de transporte do pedido ' + this.idCupom;
          this.buscarTransportadoras();
        } else {
          this.texto = 'Dados de separação do pedido ' + this.idCupom;
        }
        this.buscarEnderecoDeEntrega();
        break;
      }

      default:
        break;
    }
  }

  buscarDadosSeparacao() {
    this.carregandoService.mostra('buscaDadosSeparacao');
    this.premissasService.consultarDadosSeparacaoObg().subscribe(resp => {
      this.obrigarPreencherCampos = resp.valor;
      this.carregandoService.esconde('buscaDadosSeparacao');
    }, (erro) => {
      this.carregandoService.esconde('buscaDadosSeparacao');
      this.notificacaoService.erro('Não foi possível verificar a configuração que torna o preenchimento de todos os campos obrigatórios.')
    });
  }

  buscarEnderecoDeEntrega() {
    this.carregandoService.mostra('buscarEnderecoDeEntrega');
    this.pedidoService.buscarEnderecoDeEntrega(this.idCupom).subscribe(f => {
      this.dadosSeparacao = f;

      if (this.dadosSeparacao === null || this.dadosSeparacao === undefined) {
        this.dadosSeparacao = new DadosSeparacao();
      }

      if (this.dadosSeparacao.peso === null || this.dadosSeparacao.peso === undefined) {
        this.dadosSeparacao.peso = this.data.peso;
      }

      if (this.dadosSeparacaoTransporte.idTransportadora === null || this.dadosSeparacaoTransporte.idTransportadora === undefined) {
        this.dadosSeparacaoTransporte.idTransportadora = this.data.idTransportadora;
      }

      this.carregandoService.esconde('buscarEnderecoDeEntrega');
    }, (erro) => {
      this.carregandoService.esconde('buscarEnderecoDeEntrega');
      this.notificacaoService.erro(erro);
    });
  }

  buscarTransportadoras() {
    this.carregandoService.mostra('buscarTransportadoras');

    this.transportadoraService.consultarTransportadoras().subscribe(dados => {
      this.transportadoras = dados;

      this.carregandoService.esconde('buscarTransportadoras');
    }, () => {
      this.carregandoService.esconde('buscarTransportadoras');
    });
  }

  salvar() {

    switch (this.tipo) {
      // integração
      case 1:
        this.dialogRef.close({ codErp: this.codErp });
        break;

      // separação
      case 4: {
        if (this.separacaoTransporte) {
          if (this.tipoFrete === 0) {
            this.dadosSeparacaoTransporte.tipoEntrega = null;
          } else if (this.tipoFrete === 1 && this.dadosSeparacaoTransporte.tipoEntrega === 0) {
            this.dadosSeparacaoTransporte.idTransportadora = null;
          }

          this.dialogRef.close(this.dadosSeparacaoTransporte);
        } else {
          this.dadosSeparacao.peso = Number(this.dadosSeparacao.peso);
          this.dadosSeparacao.volume = Number(this.dadosSeparacao.volume);
          this.dialogRef.close(this.dadosSeparacao);
          break;
        }
      }

      default:
        break;
    }
  }

  fechar() {
    this.dialogRef.close();
  }
}
